import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDashboardContext } from './DashboardContext'; // or wherever it's stored

const AuthContext = createContext();
const publicRoutes = ['/login', '/register'];

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;
    const { resetDashboardState } = useDashboardContext();
    const location = useLocation();

    useEffect(() => {
        const checkUser = async () => {
          try {
            // Always check with backend to confirm valid session
            const response = await axios.get(`${apiUrl}/api/current_user`, {
              withCredentials: true,
            });
      
            setUser(response.data.user);
            localStorage.setItem('user', JSON.stringify(response.data.user));  // Optional: cache user info
          } catch (error) {
            console.error('Error fetching current user:', error);
            localStorage.removeItem('user');  // Clean up stale storage
            if (!publicRoutes.includes(location.pathname)) {
                navigate('/login');
            }
          } finally {
            setLoading(false);
          }
        };
      
        checkUser();
      }, [navigate, apiUrl, location]);      

    const login = async (username, password) => {
        try {
            const response = await axios.post(`${apiUrl}/api/login`, { username, password }, {
                withCredentials: true
            });
            if (response.status === 200) {
                setUser(response.data.user);
                var permissions = JSON.stringify(response.data.user.permissions);
                localStorage.setItem("permissions", JSON.stringify(response.data.user.permissions));
                if (permissions.indexOf("view_dashboard") > -1){
                    navigate('/employee-dashboard');
                }else {
                    if (permissions.indexOf("view_exfac_dashboard") > -1){
                        navigate('/ex-fac-dashboard');
                    } else {
                        navigate('/employee-dashboard');
                    }
                }
            } else {
                console.error('Login failed:', response.statusText);
            }
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    const logout = async () => {
        try {
            await axios.post(`${apiUrl}/api/logout`, {}, {
                withCredentials: true
            });
            setUser(null);
            localStorage.removeItem('user');
            localStorage.removeItem('permissions');
            localStorage.removeItem('token');

             // Also clear chat history
             resetDashboardState();
            navigate('/login');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const register = async (username, email, first_name, last_name, password, is_rep) => {
        try {
            const response = await axios.post(`${apiUrl}/api/register`, 
            { username, email, first_name, last_name, password, is_rep }, 
            {
                withCredentials: true
            });
            return response.data.message || 'Registration successful!'; // Adjust this as per your server response
        } catch (error) {
            console.error('Registration failed:', error);
            return error.response.data.error || 'Registration failed!';
        }
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, register }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
